import {Dispatch} from "redux";
import {getContainer} from "../ioc/IOCSetup";
import {
    PaymentMethod,
    PaymentResultCode,
    PaymentType,
    PlayerOrder,
    Priority,
    RequestWithdrawResponse,
    TransferLimit,
    WithdrawContext
} from "../http/protocol";
import {AppState} from "../RootReducer";
import {PriorityType} from "../http/Types";
import {onUserWithdrawRequested} from "../events/UserEvents";
import { CryptoFormData } from "../ui/withdraw/CryptoDetails";

export enum WithdrawActionType {
    SELECT_CURRENCY = "@payments/withdraw/selectCurrency",
    INIT_WITHDRAW_REQUEST = "@payments/withdraw/init/request",
    INIT_WITHDRAW_RESPONSE = "@payments/withdraw/init/response",
    INIT_WITHDRAW_ERROR = "@payments/withdraw/init/error",
    PROVIDER_REQUEST = "@payments/provider/request",
    PROVIDER_RESPONSE = "@payments/provider/response",
    PROVIDER_ERROR = "@payments/provider/error",
    UPDATE_WITHDRAW_ADDRESS= "@payments/withdraw/recipientAddress/update",
    UPDATE_DESTINATION_TAG= "@payments/withdraw/destinationTag/update",
    SET_AMOUNT= "@payments/withdraw/amount/select",
    UPDATE_AMOUNT = "@payments/withdraw/amount/update",
    RESET = "@payments/withdraw/reset",
    CONFIRM_WITHDRAW = "@payments/withdraw/confirm",
    SELECT_METHOD_WITH_CONTEXT = "@payments/withdraw/confirm-with-context",
    SELECT_METHOD = "@payments/withdraw/select",
    WITHDRAW_CONTEXT_REQUEST = "@payments/withdraw/context/request",
    WITHDRAW_CONTEXT_RESPONSE = "@payments/withdraw/context/response",
    WITHDRAW_CONTEXT_ERROR = "@payments/withdraw/context/error",
    SHOW_POSSIBLE_WITHDRAW_ERRORS = "@payments/deposit/show/errors",
    UPDATE_ORDER_CUSTOM = "@payments/order/custom",
    UPDATE_NOTES_TAG = "@payments/withdraw/notesTag/update",
    RESET_WITHDRAW_CONTEXT = "@payments/withdraw/reset/context",
    UPDATE_WITHDRAW_FORM_DATA = "@payments/withdraw/form/update"
}
export type WithdrawActions =
    | { type : WithdrawActionType.INIT_WITHDRAW_REQUEST, request : { provider : string, order : PlayerOrder }}
    | { type : WithdrawActionType.INIT_WITHDRAW_RESPONSE, response : RequestWithdrawResponse }
    | { type : WithdrawActionType.INIT_WITHDRAW_ERROR, error : Error }
    | { type : WithdrawActionType.UPDATE_WITHDRAW_ADDRESS, recipientAddress : string }
    | { type : WithdrawActionType.UPDATE_DESTINATION_TAG, destinationTag : string }
    | { type : WithdrawActionType.SET_AMOUNT }
    | { type : WithdrawActionType.SELECT_CURRENCY, currency : string }
    | { type : WithdrawActionType.UPDATE_AMOUNT, amount : string, limit?:TransferLimit }
    | { type : WithdrawActionType.CONFIRM_WITHDRAW, priority : PriorityType}
    | { type : WithdrawActionType.SELECT_METHOD, method : PaymentMethod }
    | { type : WithdrawActionType.WITHDRAW_CONTEXT_REQUEST}
    | { type : WithdrawActionType.WITHDRAW_CONTEXT_ERROR }
    | { type : WithdrawActionType.WITHDRAW_CONTEXT_RESPONSE, method : PaymentMethod, context : WithdrawContext, currencyCode : string }
    | { type : WithdrawActionType.SHOW_POSSIBLE_WITHDRAW_ERRORS }
    | { type : WithdrawActionType.UPDATE_NOTES_TAG, notesTag: string }
    | { type : WithdrawActionType.UPDATE_ORDER_CUSTOM, custom : any }
    | { type : WithdrawActionType.RESET_WITHDRAW_CONTEXT }
    | { type : WithdrawActionType.UPDATE_WITHDRAW_FORM_DATA, payload : Record<string, string> };

export const resetWithdrawContext = () => {
    return { type : WithdrawActionType.RESET_WITHDRAW_CONTEXT };
}

export const showPossibleWithdrawErrors = () => {
    return { type : WithdrawActionType.SHOW_POSSIBLE_WITHDRAW_ERRORS};
}

export const updateOrderCustom = (custom : any) => {
    return { type : WithdrawActionType.UPDATE_ORDER_CUSTOM, custom : custom};
};
export const updateWithdrawAmount = (amount : string, limit?:TransferLimit) => {
    return { type : WithdrawActionType.UPDATE_AMOUNT, amount : amount, limit:limit};
};
export const updateWithdrawAddress = (recipientAddress : string) => {
    return { type : WithdrawActionType.UPDATE_WITHDRAW_ADDRESS, recipientAddress : recipientAddress};
};
export const updateDestinationTag = (destinationTag : string) => {
    return { type : WithdrawActionType.UPDATE_DESTINATION_TAG, destinationTag : destinationTag};
};

export const updateNotesTag = (notesTag : string ) => {
    return { type : WithdrawActionType.UPDATE_NOTES_TAG, notesTag : notesTag};
}

export const setWithdrawAmount = () => {
    return { type : WithdrawActionType.SET_AMOUNT}
};

export const confirmWithdraw = (priority? : string) => {
    return  { type : WithdrawActionType.CONFIRM_WITHDRAW, priority : priority}

};


function toPriority(prio : string) {
    let priority : Priority = Priority[prio.toUpperCase() as keyof typeof Priority];
    return priority;
}
export function initWithdraw() {
    return (dispatch : Dispatch, getState : () => AppState) => {
        let withdraw = getState().payments.withdraw;
        if(withdraw.activeMethod &&  withdraw.activeMethod.provider) {
            let provider = withdraw.activeMethod.provider;
            let amount = withdraw.amount;
            let order : PlayerOrder  = {
                type : PaymentType.WITHDRAWAL,
                currencyCode : withdraw.activeCurrency,
                method : withdraw.activeMethod.code,
                recipientAddress: withdraw.recipientAddress,
                custom : withdraw.orderCustom,
                destinationTag : (withdraw.destinationTag && withdraw.destinationTag.length > 0) ? withdraw.destinationTag : undefined,
                notes : (withdraw.notesTag && withdraw.notesTag.length > 0) ? withdraw.notesTag : undefined

            };
            if(amount) {
                order = {...order,  amount : parseFloat(amount)}
            } else {
                order = {...order,  amount : 0}
            }

            if(withdraw.priority) {
                order = {...order, priority : toPriority(withdraw.priority)};
            }
            dispatch({type : WithdrawActionType.INIT_WITHDRAW_REQUEST, request : { provider : provider, order : provider}});

            let methodKey = `${order.method}-${order.currencyCode}-withdrawAddress`;

            if(withdraw.activeMethod.achBankTransfer == false  &&  withdraw.activeMethod.code != "paymentiq") {
                let userSettingsValue = order.recipientAddress ? order.recipientAddress : "";
                if(order.destinationTag && order.destinationTag.length > 0) {
                    userSettingsValue+=":" + order.destinationTag;
                }
                if(userSettingsValue.length > 0) {
                    getContainer().getUserService().updateUserSettings(methodKey, userSettingsValue).then(() => {
                        console.log("User settings update!");
                    }).catch(e => console.log(e));
                }

            }


            getContainer().getPaymentsService().requestWithdraw(withdraw.activeMethod.provider, order).then((resp : RequestWithdrawResponse)=>{
                if(resp.result == PaymentResultCode.OK) {
                    try {
                        let userUid = getState().user?.user?.userUid;
                        userUid && onUserWithdrawRequested(userUid, amount ? amount : "0", order.currencyCode,  withdraw.activeMethod?.provider)
                    } catch (e) {
                    }

                }
                dispatch({ type : WithdrawActionType.INIT_WITHDRAW_RESPONSE, response : resp });
            }).catch(err => {
                dispatch({ type : WithdrawActionType.INIT_WITHDRAW_ERROR, error : err })
            });
        } else {
            console.error("Withdraw state is not valid to initiate a withdrawal", withdraw);
        }


    }
}

export function updateWithdrawFormData({recipientAddress, amount, destinationTag, notesTag}: CryptoFormData) {
    // Map form data directly to Redux state fields, filtering out undefined values - priority is sent directly in the confirmWithdraw action
    const payload = {
      recipientAddress,
      amount,
      destinationTag,
      notesTag
    };

    return {
      type: WithdrawActionType.UPDATE_WITHDRAW_FORM_DATA,
      payload
    };
  }